import { Box } from 'native-base';
import React, { ReactNode } from 'react';
import { StyleProp, ViewStyle } from 'react-native';
import Modal from 'react-native-modal';
import styled from 'styled-components/native';

import { Button } from '~/components/button';
import { Color } from '~/components/color';
import { ButtonBackIcon } from '~/components/icon';
import { ModalAccessibilityContainer } from '~/components/modal-accessibility';
import { useIntl } from '~/contexts/intl';
import { isWeb } from '~/utils';

export type ModalPickerProps = {
    bottomPadding?: boolean;
    extraStyles?: StyleProp<ViewStyle>;
    visible: boolean;
    contentKey?: string;
    renderContent: () => ReactNode;
    renderActions: () => ReactNode;
    onCancel: () => void;
    onModalHide?: () => void;
};

const Card = styled.View`
    background-color: ${Color.BACKGROUND_DEFAULT};
    padding: 16px;
    margin-bottom: 8px;
    border-radius: 16px;

    align-items: center;
`;

export function ModalPicker(props: ModalPickerProps) {
    const {
        visible,
        contentKey,
        renderContent,
        renderActions,
        onCancel,
        onModalHide,
        extraStyles,
        bottomPadding = true
    } = props;
    const { formatMessage } = useIntl();

    return (
        <Modal
            isVisible={visible}
            accessibilityViewIsModal
            animationIn="slideInUp"
            animationOut="slideOutDown"
            backdropOpacity={0.6}
            onBackdropPress={onCancel}
            onBackButtonPress={onCancel}
            onModalHide={onModalHide}
            statusBarTranslucent
            style={extraStyles ?? {}}
        >
            <ModalAccessibilityContainer key={contentKey} active={visible}>
                <Box style={{ position: isWeb() ? 'relative' : 'absolute' }}>
                    <Card style={{ paddingBottom: bottomPadding ? 16 : 2 }}>
                        {renderContent()}
                        {renderActions()}
                    </Card>
                    <Button
                        label={formatMessage('modal-picker.back')}
                        alignCenter
                        type="basic"
                        shape="rounded"
                        leftIcon={ButtonBackIcon}
                        onPress={onCancel}
                    />
                </Box>
            </ModalAccessibilityContainer>
        </Modal>
    );
}
